function mountManagementApp({
  Framework,
  RootComponent,
  AdminButton,
  router,
  store,
  productionTip,
  authenticatedActions,
}) {
  Framework.component('AdminButton', AdminButton);
  Framework.config.productionTip = productionTip;

  new Framework({
    router,
    store,
    beforeCreate() {
      if (this.$store.state.isLogin) {
        authenticatedActions.forEach((action) => this.$store.dispatch(action));
      }
    },
    render: (createElement) => createElement(RootComponent),
  }).$mount('#app');
}

module.exports = mountManagementApp;
